module.exports = __webpack_public_path__ + "static/planwell_green-4f6e5234d3f1485498230d025e5247c8.png";